import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

export const isExternalFinanceStoreSubscription = (user) =>
  user?.store?.subscriptionType === "External";

const BlockExternalFinanceTierPages = ({ user, children }) =>
  isExternalFinanceStoreSubscription(user) ? (
    <Navigate to="/warehousing/finance" replace />
  ) : (
    children
  );

const mapStateToProps = (state) => ({ user: state.auth?.user });

export const FinanceTierAccessRoute = connect(mapStateToProps)(BlockExternalFinanceTierPages);
